import { CheckIcon, CopyLinkIcon, EyeIcon, GlobeIcon, LockIcon, ViewIcon } from "../assets/icons/icons";
export const GROUP_LIMIT = 25;
export const USER_LIMIT = 25;
export const DELETE = "DELETE";
export const CLONE = "CLONE";
export const SHARE = "SHARE";
export const SHARE_EDIT = "SHARE_EDIT";
export const SCENE = "SCENE";
export const HOTSPOT = "HOTSPOT";

export const IMAGE = "IMAGE";
export const VIDEO = "VIDEO";
export const PDF = "PDF";
export const AUDIO = "AUDIO";
export const MEDIA = "MEDIA";
export const LINK = "LINK";


export const accesControls = [
  {
    name: "View",
    access: "public",
    info: "Anyone with the link can view",
    iconURL: <ViewIcon />,
  },
  {
    name: "Restricted",
    access: "private",
    info: "Only people with access can open with the link",
    iconURL: <LockIcon />,
  },
  // {
  //   name: "Anyone with the link",
  //   access: "anyone",
  //   info: "Anyone on the internet with the link can view",
  //   iconURL: <GlobeIcon />,
  // },
];
